import { baseApi } from './base.service';
import { getUserPermissionsIds } from './query-functions';
import { GetUserPermissionsIds } from './query-functions/get-user-permissions-ids';

export const userPermissionsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getUserPermissionsIds: build.query<Record<any, any>, {}>({
      // @ts-ignore
      async queryFn({ apiToken, objectId, requestType }: GetUserPermissionsIds) {
        const result = await getUserPermissionsIds({ apiToken, objectId, requestType });
        return { data: result };
      },
    }),
  }),
});

export const { useGetUserPermissionsIdsQuery } = userPermissionsApi;
